import React from 'react';
import styled from 'styled-components';
import Modal from '../Modal';
import { Button } from '@mantine/core';
import { Box } from '@mantine/core';

export const WarningPopup = ({
  isOpen,
  onClose,
  /** Modal and content props **/
  title = 'Warning',
  description = 'Are you sure you want to proceed with this action?',

  /** Button labels **/
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',

  /** Loading & handlers **/
  isLoading = false,
  onConfirm
}) => {
  return (
    <Modal open={isOpen} toggle={onClose} title={title}>
      <>
        <Box maw={378}>
          <Text dangerouslySetInnerHTML={{ __html: description }} />
          <Actions>
            <Button size="xs" variant="outline" className="text-secondary" onClick={onClose}>
              {cancelLabel}
            </Button>
            <Button size="xs" onClick={onConfirm} loading={isLoading} disabled={isLoading}>
              {confirmLabel}
            </Button>
          </Actions>
        </Box>
      </>
    </Modal>
  );
};

const Text = styled.p`
  max-width: 529px;
  color: #495057;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 19.6px */
  margin-top: 8px;
`;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;

  button {
    margin-left: 8px;
    min-width: 100px;

    &.text-secondary {
      color: #495057;
      border: 1px solid #ced4da;
    }
  }
`;
